module.exports = __webpack_public_path__ + "img/taxes.9aa8590d.svg";